import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule, KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoggerService } from '../../logger.service';
import { PickerComponent, PickerModule } from "@ctrl/ngx-emoji-mart";
import { EmojiComponent } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { Align, KENDO_POPUP, PopupRef, PopupService } from '@progress/kendo-angular-popup';

@Component({
  selector: 'casi-emoji-content',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    LayoutModule,
    PickerModule,
    PickerComponent,
    EmojiComponent,
    KENDO_POPUP,
    KENDO_BUTTONS
  ],
  templateUrl: './emoji-content.component.html',
  styleUrl: './emoji-content.component.scss'
})
export class EmojiContentComponent {
  private popupRef: PopupRef | undefined;

  private _emojiInput: any | undefined;
  @Input() set emojiInput(val: any | undefined) {
    this._emojiInput = val;
    this.selectedEmoji = val;
  };
  get emojiInput() {
    return this._emojiInput;
  }

  @Output() onSave = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<void>();

  public popupAlign: Align = { horizontal: "right", vertical: "top" };
  public show = false;

  public onClick(): void {
    this.show = !this.show;
  }

  public selectedEmoji: any | undefined = undefined; // { id: 'santa', skin: 3 };
  constructor(
    private logger: LoggerService,
    private popupService: PopupService
  ) { }

  //#region Event Handlers

  ngOnInit(): void {
    this.logger.debug('ngOnInit...',);
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
  }

  ngAfterContentInit(): void {
    this.logger.debug('ngAfterContentInit...');
  }

  //#endregion

  emojiSelected(event: any) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.logger.debug(`emojiSelected:`, event);
    this.selectedEmoji = event.emoji;
    this.onSave.emit(this.selectedEmoji);
    // this.emojiInput$?.next(event.emoji.native);
  }

  onSubmit(): void {
    this.logger.debug(`onSubmit...`, this.selectedEmoji);
    this.onSave.emit(this.selectedEmoji);
  }

  closeWindow(): void {
    this.logger.debug(`closeWindow...`);
    this.onCancel.emit();
  }

}
